<script setup lang="ts">
  import type { TSubCategories } from '@/types/OrigDest'
  import useFSFDataLayer from '@/composables/data-layers/useFSFDataLayer'

  const props = withDefaults(
    defineProps<{
      items: TSubCategories[] | null
      name?: string
      disabled?: boolean
    }>(),
    {
      items: null,
      name: '',
      disabled: false
    }
  )

  const modalValue = defineModel<string>()

  const suppressFsfLabelsTracking = inject<boolean>('suppressFsfLabelsTracking', false)
  const { pushFSFDataLayer } = useFSFDataLayer()
  function onSubCategoriesClick(value: string) {
    if (suppressFsfLabelsTracking) return

    pushFSFDataLayer({
      generic_event_name: 'fsf_labels_2nd_level',
      event_category: value,
      event_label: props.name.toLowerCase()
    })
  }
</script>

<template>
  <ListboxRoot
    v-model="modalValue"
    @update:model-value="(newVal) => onSubCategoriesClick(newVal as string)"
  >
    <ListboxContent class="mx-4">
      <ListboxGroup>
        <ListboxGroupLabel
          v-if="name"
          class="items-left mt-2 flex min-h-6 items-center text-subtitle-1"
        >
          {{ name }}
        </ListboxGroupLabel>
        <ListboxItem
          v-for="item in items"
          :key="item.key"
          :value="item.key"
          :disabled="disabled"
          class="my-2 flex h-10 w-full cursor-pointer select-none items-center rounded px-4 text-subtitle-1 hover:bg-divider data-[state=checked]:bg-divider"
        >
          <span>{{ item.value }}</span>
        </ListboxItem>
      </ListboxGroup>
    </ListboxContent>
  </ListboxRoot>
</template>
